<!--
 * @Author: qinmengyuan
 * @Date: 2024-05-11 11:49:01
 * @LastEditors: ttheitao
 * @LastEditTime: 2024-06-14 15:19:21
 * @FilePath: \onetab\src\external-components\index.vue
-->
<template>
  <div class="mask" @click.self="handleClose">
    <Transition name="modal-fade">
      <div
        v-if="isShow"
        :class="{ 'kb-backed': true, isFull }"
      >
        <div class="header">
          <div class="title">{{ detail?.name }}</div>
          <div class="icon">
            <RaIcon
              :icon="isFull ? 'FullScreenExit' : 'FullScreen'"
              :size="24"
              @click="isFull = !isFull"
            />
            <RaIcon icon="Close" :size="24" @click="handleClose" />
          </div>
        </div>

        <div v-loading="loading" :style="{ width: '100%', height: 'calc(100% - 38px)' }">
          <iframe
            :src="newSrc"
            :style="{ width: '100%', height: 'calc(100%)' }"
            @load="handleLoaded"
          ></iframe>
        </div>
        </div
    ></Transition>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, computed } from 'vue';
import { user } from '../store/user';
import { RaIcon } from '@rafter/icon';
const emits = defineEmits(['close']);
const props = defineProps({
  detail: {
    type: Object,
    default: () => ({}),
  },
});
const isFull = ref(false);
const loading = ref(true);
const isShow = ref(false);
const handleLoaded = () => {
  loading.value = false;
};
onMounted(() => {
  isShow.value = true;
  document.addEventListener('keydown', handleKeyDown);
});
const handleClose = () => {
  isShow.value = false;
  setTimeout(() => {
    emits('close');
  }, 150);
};
const handleKeyDown = (event) => {
  if (event.key === 'Escape') {
    handleClose();
  }
};
onBeforeUnmount(() => {
  document.removeEventListener('keydown', handleKeyDown);
});

const newSrc = computed(()=>{
  const {detail} = props;
  let src = `./little-components/${detail?.url}/index.html?token=${user.token}`;

  if(detail.url.startsWith('http')){
    src = `${detail.url}${detail.url.includes('?') ? '&' : '?'}token=${user.token}`;
  }

  return src;
});
</script>
<style lang="scss" scoped>
.mask {
  width: 100vw;
  height: 100vh;
  background-color: rgba(26, 26, 26, 0.4);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
}
.kb-backed {
  width: 70vw;
  height: 90vh;
  max-height: 650px;
  background-color: white;
  border-radius: 16px;
  overflow: hidden;
  user-select: none;
  position: absolute;
  z-index: 1;
  .header {
    height: 38px;
    display: flex;
    background: white;
    box-shadow: 0px 1px 0px 0px #f0f1f4;
    position: relative;
    align-items: center;
    justify-content: center;
    .title {
      color: var(--text-on-surface-primary, #181b22);
      /* web/cn/heading/heading-02 */
      font-family: 'PingFang SC';
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%; /* 24px */
      letter-spacing: 0.5px;
    }
  }
  .icon {
    position: absolute;
    right: 12px;
    display: flex;
    align-items: center;
    top: 7px;
    gap: 16px;
  }
}
.isFull {
  width: 100vw;
  height: 100vh;
  border-radius: 0;
  max-height: none;
}
</style>
